import { type ModalQueue, useModalHistory } from '@carvana/merch-react-hooks';
import Router from 'next/router';
import { isNonProd } from '~/constants/environment';
import useDisableModalHistory from '~/hooks/common/useDisableModalHistory';

export type Props = {
  modalQueue: ModalQueue;
};

export default function PagesRouterModalHistory({ modalQueue }: Props) {
  useModalHistory(modalQueue, {
    disable: useDisableModalHistory(),
    logToConsole: isNonProd,
    nextJsBeforePopState: Router.beforePopState
  });

  return null;
}
